import {KTSVG} from '../../../_metronic/helpers'
import {FC, useEffect, useState, forwardRef, useImperativeHandle} from 'react'


import {useAllpaymenttypes, useAllcustomers,useUpdatesalesinvoices, usePaymentrequest} from '../../contextProviders/Atomqueryprovider'

import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Modal} from 'react-bootstrap'
import Select from 'react-select'
import { useSelectStyles } from '../../helpers/useSelectStyles'
type Props = {
 
  show: boolean
  handleClose: () => void
  ref: any
}
const uuidTime = () => {
  return new Date().valueOf()
}

const CURRENCY_APP = process.env.REACT_APP_CURRENCY



const initialValues = {
  request_accountreference: '',
  request_party: '',
  request_amount: 0,
  
}

const productSchema = Yup.object().shape({
  request_accountreference: Yup.string().required('The account reference required'),
  request_party: Yup.string().required('A phone number is required')
  .matches(/^254\d{9}$/, { message: 'Invalid phone number format. The number should be in the following format 254*********' }),
  request_amount: Yup.number().required('The request amount is required')
  .min(1, 'The request amount must be greater than or equal to 1')
  
})
export const Mpesastk: FC<Props> = forwardRef((props, ref) => {
 
  const [requestdata, setRequestdata] = useState<any>({})

  const [loading, setLoading] = useState(false)
  const [submittingready, setSubmittingready] = useState<boolean>(false)
  //customer id and payment type

  const [accountreference, setAccountreference] = useState<any>('')
  
const {mutateAsync: paymentrequestmutateAsync} = usePaymentrequest(
  requestdata
)


  const formik = useFormik({
    initialValues,
    validationSchema: productSchema,
    validateOnBlur: true,
    onSubmit: async (values, {setStatus, setSubmitting, resetForm}) => {
      setLoading(true)
 
      setRequestdata({
        request_accountreference: values.request_accountreference,
        request_party: values.request_party,
        request_amount: values.request_amount
        
      })

      setSubmittingready(true)
    },
  })


 
  useEffect(() => {
    if (submittingready && requestdata) {

      
      paymentrequestmutateAsync(requestdata, {
        onSuccess: () => {
          setLoading(false)
          formik.resetForm({})
          formik.setSubmitting(false)
          setRequestdata({})
          setSubmittingready(false)
          props.handleClose()
        },
        onError(error, variables, context) {
          formik.setStatus('The request details are incorrect')
          formik.setSubmitting(false)
          setLoading(false)
        },
      })
    }
  }, [submittingready])

  useEffect(() => {
    if (accountreference) {
      
      formik.setFieldValue('request_accountreference', accountreference)
      formik.setFieldValue('request_amount', 1)
      
    }
  }, [accountreference])

  useImperativeHandle(ref, () => ({
    Resetmodalmpesavalues() {
     setAccountreference(uuidTime)
     formik.resetForm({})
          formik.setSubmitting(false)
          setRequestdata({})
          setSubmittingready(false)
    }
  }))


  return (
    <Modal
      className='modal fade'
      id='kt_modal_dashboard'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={props.show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={props.handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>STK Request
          <span className='h-10px border-gray-200 border-start mx-2'></span>

           <span className='text-muted fw-bold fs-6'>{accountreference}</span></h3>

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={props.handleClose}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form 
          id='kt_modal_add_mpesastk_form'
          noValidate
          className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
          onSubmit={formik.handleSubmit}
          >
        {/* begin::Input group */}

        <div className='row fv-row mb-7'>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Account Reference</label>
                  <input
                    placeholder={accountreference}
                   
                    {...formik.getFieldProps('request_accountreference')}
                    autoComplete='off'
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid':
                          formik.touched.request_accountreference && formik.errors.request_accountreference,
                      },
                      {
                        'is-valid':
                          formik.touched.request_accountreference && !formik.errors.request_accountreference,
                      }
                    )}
                  />
                  {formik.touched.request_accountreference && formik.errors.request_accountreference && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.request_accountreference}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
              
            </div>

            {/* end::Input group */}

            {/* begin::Input group */}

        <div className='row fv-row mb-7'>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Phone Number</label>
                  <input
                    placeholder={"254723456789"}
                   
                    {...formik.getFieldProps('request_party')}
                    autoComplete='off'
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid':
                          formik.touched.request_party && formik.errors.request_party,
                      },
                      {
                        'is-valid':
                          formik.touched.request_party && !formik.errors.request_party,
                      }
                    )}
                  />
                  {formik.touched.request_party && formik.errors.request_party && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.request_party}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
              
            </div>

            {/* end::Input group */}
            {/* begin::Input group */}

        <div className='row fv-row mb-7'>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Requested Amount ({CURRENCY_APP})</label>
                  <input
                   
                    placeholder='1'
                    min='1'
                    step='1'
                    type={'number'}
                    
                    {...formik.getFieldProps('request_amount')}
                    autoComplete='off'
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid':
                          formik.touched.request_amount && formik.errors.request_amount,
                      },
                      {
                        'is-valid':
                          formik.touched.request_amount && !formik.errors.request_amount,
                      }
                    )}
                  />
                  {formik.touched.request_amount && formik.errors.request_amount && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.request_amount}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
              
            </div>

            {/* end::Input group */}
              
          </form>
        </div>

        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={props.handleClose}>
            Cancel
          </button>

          <button
            type='submit'
            form='kt_modal_add_mpesastk_form'
            className='btn btn-success'
            disabled={formik.isSubmitting || !formik.isValid || !formik.dirty}
          >
            {!loading && <span className='indicator-label'>Request Payment</span>}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
})
